import classNames from 'classnames';
import React from 'react';
import { formatPrice } from 'utils';

interface ISubTotalsRow {
  bookingCurrencySymbol: string | null | undefined;
  subTotalPurchaseCents: number;
  subTotalSalesCents: number;
  isTa: boolean;
  className?: string;
}

export const SubtotalsRow = (props: ISubTotalsRow) => {
  const { subTotalPurchaseCents, subTotalSalesCents, bookingCurrencySymbol } = props;

  return (
    <div
      className={classNames('grid gap-20px items-center mt-20px', props.className, {
        'grid-cols-[1fr_24px]': !props.isTa,
        'grid-cols-[1fr]': props.isTa,
      })}
    >
      <div className="flex items-center gap-20px justify-self-end">
        <span className="uppercase text-xs">Subtotal</span>
        {!props.isTa && (
          <span className="purchase-cost w-[110px] bg-blue-10 border text-base border-solid border-gray-40 p-2 font-pt-sans font-bold text-right">
            {bookingCurrencySymbol}
            {subTotalPurchaseCents != undefined && formatPrice(subTotalPurchaseCents / 100)}
            {subTotalPurchaseCents == undefined && '0.00'}
          </span>
        )}
        <span className="subtotal block w-[110px] bg-teal-20 p-2 text-base text-right font-bold font-pt-sans">
          {bookingCurrencySymbol}
          {subTotalSalesCents != undefined && formatPrice(subTotalSalesCents / 100)}
          {subTotalSalesCents == undefined && '0.00'}
        </span>
      </div>
    </div>
  );
};
